import { getOnlyDate } from '~/astra'
import { createBatchPractitionerScheduleStatus } from '~/store/di-entity.api.generated'
import { createMinimalStatusId } from '~/store/slices/surgeonSchedulerSlice'
import { useStore } from '~/store/store'
import { selectPractitionerScheduleStatus, selectPractitionerStatusDefinition } from '~/storm'

import { DatePractitionerCell } from './utils'

export async function saveStatuses(statusCode: string, cells: DatePractitionerCell[]) {
    const state = useStore.getState()
    const { addBatchPendingStatus, deleteBatchPendingStatus } = state.surgeonScheduler.actions

    const definition = selectPractitionerStatusDefinition(state, { where: { code: statusCode } })
    if (!definition) return 0

    const cellsWithoutStatus = cells.filter(
        ({ date, practitionerId }) =>
            !selectPractitionerScheduleStatus(state, {
                where: {
                    scheduled_date: getOnlyDate(date),
                    status_code: statusCode,
                    practitioner_id: practitionerId,
                },
            })
    )

    const statusesToCreate = cellsWithoutStatus.map(({ date, practitionerId }) => ({
        practitioner_id: practitionerId,
        scheduled_date: getOnlyDate(date),
        status_code: statusCode,
        practitioner_status_definition_uuid: definition.uuid,
    }))

    addBatchPendingStatus(
        statusesToCreate.map(s => ({
            practitionerId: s.practitioner_id,
            status_code: s.status_code,
            color: definition.color,
            label: definition.label,
            date: s.scheduled_date,
        }))
    )

    try {
        await createBatchPractitionerScheduleStatus(statusesToCreate)
    } finally {
        deleteBatchPendingStatus(
            statusesToCreate.map(s =>
                createMinimalStatusId({
                    date: s.scheduled_date,
                    practitionerId: s.practitioner_id,
                    status_code: s.status_code,
                })
            )
        )
    }

    return statusesToCreate.length
}
